import Decimal from "decimal.js";
import { CalculateCostsResponse } from "@forgepoint/shared";

/** The per-quantity `marginsByType` breakdown returned by calculate-costs. */
type MarginsByType = CalculateCostsResponse["costs"][number]["marginsByType"];

/**
 * Sums the present per-category margin amounts into the item's total margin
 * for a quantity. This is the true margin (basePrice − loadedCost) and, unlike
 * `unitPrice − unitCost`, excludes any PRICE-phase pricing lines. Returns "0"
 * when there are no margins. The value is a decimal string.
 */
export function sumMargins(marginsByType: MarginsByType): string {
  if (!marginsByType) {
    return "0";
  }
  return Object.values(marginsByType)
    .reduce((sum, amount) => sum.plus(amount ?? 0), new Decimal(0))
    .toString();
}
